import React, { useState, useEffect }  from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';

import { TailSpin } from 'react-loader-spinner';
import PinInput from 'react-pin-input';

const VerifyEmailModal = ({ 
    verifyEmailModal,
    handleVerifyEmailModalHide,
    handleSubmitVerifyEmail,
    verifyEmailLoading,
    email,
    verifyEmailMessage,
    verifyEmailErr,
    verifyEmailErrMessage,
    sendOTP
}) => {
    
    const pinStyleCss = {
        padding : '10px'
    }
    const pinInputStyleCss = {
        borderColor : '#777',
        borderRadius : '8px',
        borderWidth : '1px',
        backgroundColor : 'rgba(57,56,62,0.75)',
        color : '#eee',
        fontSize : '1.5rem'
    }
    const pinInputFocusStyleCss = {
        borderRadius : '8px',
        borderWidth : '2px',
        color : '#eee',
        fontSize : '1.5rem'
    }
    
    return (
        <Modal
            // size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={verifyEmailModal}
            onHide={handleVerifyEmailModalHide}
            className='profileModal'
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Verify Email
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='text-center'>

                <p className='mb-4'>
                    One time pin (OTP) has been sent to your email. Please key-in the fields provided below to verify your email.
                </p>

                <h4 className='mb-4'>{email}</h4>

                <TailSpin
                    height="32"
                    width="32"
                    color="#777"
                    ariaLabel="tail-spin-loading"
                    radius="2"
                    wrapperStyle={{margin: "1rem auto"}}
                    wrapperClass="loader"
                    visible={verifyEmailLoading}
                />


                {verifyEmailMessage!=='' && (
                    <h5 className='mb-2'>
                        <Badge bg="success">
                            Email sent successfully
                        </Badge>
                    </h5>
                )}
                {verifyEmailErr && (
                    <h5 className='mb-2'>
                        <Badge bg="danger">
                            {verifyEmailErrMessage}
                        </Badge>
                    </h5>
                )}

                

                <PinInput 
                    length={6} 
                    initialValue=""
                    // secret 
                    focus
                    onChange={(value, index) => {}} 
                    type="numeric" 
                    inputMode="number"
                    style={pinStyleCss}  
                    inputStyle={pinInputStyleCss}
                    inputFocusStyle={pinInputFocusStyleCss}
                    onComplete={handleSubmitVerifyEmail}
                    autoSelect={true}
                    regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                />

            </Modal.Body>
            <Modal.Footer>
                <Button variant="warning" className="d-flex justify-content-center" onClick={sendOTP}>
                    Resend OTP
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default VerifyEmailModal;